// extracted by mini-css-extract-plugin
export default {"video-container":"VideoJS_video-container__EsXn9"};